module.exports = __webpack_public_path__ + "static/media/view4.2beb43ca.jpg";